import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, take, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PlatformAccessService } from '../../core/src/platform-access.service';

const PAM_RETRY = new HttpContextToken<boolean>(() => false);

@Injectable()
export class PamInterceptor implements HttpInterceptor {
  private readonly platformAccessService = inject(PlatformAccessService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && !req.context.get(PAM_RETRY)) {
          this.platformAccessService.checkPlatformAccess();
          return this.platformAccessService.accessCheckResult$.pipe(
            take(1),
            switchMap((hasAccess) =>
              hasAccess
                ? next.handle(req.clone({ context: req.context.set(PAM_RETRY, true) }))
                : throwError(() => error),
            ),
          );
        }
        return throwError(() => error);
      }),
    );
  }
}
